module.exports = __webpack_public_path__ + "img/video-mobile@2x.ff04163.jpg";